import styled from 'styled-components'

import theme from 'theme'

const PaperSubtitle = styled.h3`
  margin: 20px 0;
  font-size: 16px;
  font-weight: ${theme.fontWeights.thin};
  line-height: 1.6;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

PaperSubtitle.defaultProps = {
}

PaperSubtitle.propTypes = {
}

export default PaperSubtitle
